class StatisticsBlock {
    // Types
    component: HTMLElement;
    observer: IntersectionObserver;

    // Statics
    static animateClass = 'animate';
    static jsEnabled = 'js-enabled';

    // Construct the StatisticsBlock
    constructor(component: HTMLElement) {
        // Set up the Class variables
        this.component = component;
        this.observer = new IntersectionObserver(this.triggerAnimation.bind(this), {
            threshold: 0.5,
        });

        // Add js-enabled to prep component for css animations
        this.component.classList.add(StatisticsBlock.jsEnabled);

        // Attach the component to the observer
        this.observer.observe(this.component);
    }

    // Handle when in view, only once
    triggerAnimation(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                this.component.classList.add(StatisticsBlock.animateClass);

                // We've animated, observer no longer needs to observe
                this.observer.disconnect();
            }
        });
    }
}

export default StatisticsBlock;
